export const environment = {
  production: false,
  environment: 'marketplace',
  seBaseOrigin: '',
  authenticationClientId: '',
  authenticationClientSecret: '',
  contextBaseSite: 'slb',
  contextCurrency: 'USD',
  contextLanguage: 'en',
  appConfig: {
    urlParams: ['baseSite', 'language', 'currency'],
    currency: ['USD'],
    language: ['en'],
    baseSite: ['slb'],
    occ: {
      baseUrl: '',
      prefix: 'rest/v2',
    },
  },
  authConfig: {
    loginUrl: '/v2/auth',
    logoutUrl: '/v2/slo',
  },
  appDirName: 'digital-commerce-spartacus-us',
  seo: {
    robots: {
      URL_TO_CART: '/cart',
      URL_TO_CHECKOUT: '/checkout',
      URL_TO_MY_ACCOUNT: '/my-account',
      BASE_URL: 'http://localhost:4200',
    },
  },
};
